<bn-loading-overlay></bn-loading-overlay>
<div class="d-flex justify-content-end" *ngIf="exibeListagem()" style="margin-bottom: 1em;">
    <button [disabled]="renuncias?.length == 0" class="btn btn-secondary m-0" type="button" (click)="btnExportarLista()"
    placement="top" ngbTooltip="Exporta a renúncia listada">
    <i class="fa fa-file"></i> Exportar Renúncia</button>
</div>

<div class="alert alert-info" *ngIf="!exibeListagem()">Não foi encontrada renúncia com o filtro informado</div>
<div class="table-responsive" *ngIf="exibeListagem()">
    <table class="table table-hover">
        <thead>
        <tr>
            <th>
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'nomeAgenteFinanceiro'" [nomeAtributoExibicao]="'Agente Financeiro'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao></th>
            <th class="text-center">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataCriacao'" [nomeAtributoExibicao]="'  Dt. Solicitação'"
                  (aoClickar)="mudancaOrdenacao($event)" ngbTooltip="Data/hora da solicitação da Renúncia">
                </bn-ordenacao></th>
            <th class="text-center"  container="body">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'usuarioResponsavel'" [nomeAtributoExibicao]="'Usuário Responsável'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao></th>
            <th class="text-center" container="body" ngbTooltip="Valor subscrito líquido (aporte - resgate)">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'valorRenuncia'" [nomeAtributoExibicao]="'Valor Renúncia'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao></th>
             
            <th class="text-center" container="body" ngbTooltip="Valor limite descomprometido">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'valorLimiteDescomprometimento'" [nomeAtributoExibicao]="'Valor Descomprometido'"
                    (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao></th>  

            <th class="text-center" container="body" ngbTooltip="Acréscimo 50% limite renunciante">
                    <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'acrescimoExclusivoAoLimiteRenunciante'" [nomeAtributoExibicao]="'Acréscimo 50% limite renunciante'"
                      (aoClickar)="mudancaOrdenacao($event)">
                    </bn-ordenacao></th> 
           
            <th class="text-center">
            </th>
        <tr>
        </thead>
        <tbody>
        <tr *ngFor="let renuncia of renuncias">

            <td>
                {{renuncia?.nomeAgenteFinanceiro}}
            </td>
            <td class="text-center" [ngClass]="'moeda'">
                {{ renuncia?.dataCriacao | date: 'dd/MM/yyyy HH:mm' }}
            </td>
            <td class="text-center" [ngClass]="'moeda'">
                {{ renuncia?.usuarioResponsavel }}
            </td>
            <td class="text-center" [ngClass]="'moeda'">
                {{ renuncia?.valorRenuncia | bnMask:'MOEDA' }}
            </td>
            <td class="text-center" [ngClass]="'moeda'">
              {{ renuncia?.valorDescomprometidoNovasContratacoes | bnMask:'MOEDA' }}
            </td>
            <td class="text-center" [ngClass]="'moeda'">
              {{ renuncia?.acrescimoExclusivoAoLimiteRenunciante | bnMask:'MOEDA' }}
            </td>
            <td *ngIf="podeExcluir" class="text-center" id=col-acoes>
              <a href="javascript:void(0)" *ngIf="ehAgenteFinanceiro && podeExcluir" (click)="abrirModalConfirmarExclusao(renuncia?.ide)">
                    <i class="fa fa-trash cursor-pointer margin-left-5"
                      placement="left-top"
                      ngbTooltip="Excluir a solicitação de Renúncia à Cobertura Máxima de Inadimplência"></i>
                  </a>
            </td>

        </tr>
        </tbody>
    </table>
</div>

<ng-template #modalExclusao>
  <div class="bn-form-group row">
    <div class="col">
      <label>Confirmar a exclusão da solicitação da renúncia?</label>
    </div>
  </div>
</ng-template>
<ng-template #botoesModalExclusao>
  <button class="btn btn-default" (click)="desistirExclusao()">Cancelar</button>
  <button class="btn btn-primary" (click)="excluirRenuncia()">Confirmar</button>
</ng-template>
